import BossModel from "@/models/BossModel";
import WidgetTemplate from "@/models/WebsiteWidget/WidgetTemplate";

export default class AbstractWidget extends BossModel {

    /**
     *
     * @returns {*}
     * @constructor
     */
    WidgetTemplate() {
        return WidgetTemplate.byModelName(this.constructor.model_name);
    }
}
